import CantonManager from "@stefanzweifel/js-swiss-cantons"

declare global {
    interface Window {
        jQuery: any;
    }
}

const GetCantonName = (abbreviation:string) => {
    let language = 'de'
    if (window.jQuery) {
        language = window.jQuery('html').attr('lang')
    }

    if (abbreviation !== 'FL') {

        let cantonManager = new CantonManager()
        let canton = cantonManager.getByAbbreviation(abbreviation)

        return canton.setLanguage(language).getName()
    } else {
        return 'Liechtenstein'
    }
}

export default GetCantonName
